export const messages = {
  en: {
    newOaWorkflowDetail: {
      title: 'Work Order Details',
      back: 'Back',
      applicant: 'Applicant',
      applyTime: 'Application Time',
      status: 'Status',
      workflowProcess: 'Work Order Process',
      serialNumber: 'No.',
      department: 'Department',
      handler: 'Handler',
      timeConsuming: 'Time Consuming',
      comment: 'Comment',
      processed: 'Processed',
      processing: 'Processing',
      admin: 'Administrator',
      workflowHandle: 'Work Order Handling',
      action: 'Action',
      selectAction: 'Please select',
      handle: 'Handle',
      return: 'Return',
      returnToSubmitter: 'Return to Submitter',
      end: 'End',
      transfer: 'Transfer',
      workflowDescription: 'Work Order Description',
      descriptionRequired: 'Required, please fill in the work order description',
      nextHandler: 'Next Handler',
      selectNextHandler: 'Required, please select the next handler',
      select: 'Select',
      submit: 'Submit',
      flowChart: 'Flow Chart',
      illegalOperation: 'Illegal operation',
      selectStatus: 'Please select status',
      fillDescription: 'Please fill in the description',
      submitSuccess: 'Submitted successfully',
      unknown: 'Unknown',
      apply: 'Apply',
      pendingReview: 'Pending Review',
      returned: 'Returned',
      transferred: 'Transferred',
      completed: 'Completed'
    },
  },
  zh: {
    newOaWorkflowDetail: {
      title: '工单详情',
      back: '返回',
      applicant: '申请人',
      applyTime: '申请时间',
      status: '状态',
      workflowProcess: '工单流转',
      serialNumber: '序号',
      department: '部门',
      handler: '处理人',
      timeConsuming: '耗时',
      comment: '意见',
      processed: '处理完成',
      processing: '正在处理',
      admin: '管理员',
      workflowHandle: '工单办理',
      action: '动作',
      selectAction: '请选择',
      handle: '办理',
      return: '退回',
      returnToSubmitter: '退回至提交者',
      end: '结束',
      transfer: '转单',
      workflowDescription: '工单说明',
      descriptionRequired: '必填，请填写工单说明',
      nextHandler: '下一处理人',
      selectNextHandler: '必填，请选择下一处理人',
      select: '选择',
      submit: '提交',
      flowChart: '流程图',
      illegalOperation: '非法操作',
      selectStatus: '请选择状态',
      fillDescription: '请填写说明',
      submitSuccess: '提交成功',
      unknown: '未知',
      apply: '申请',
      pendingReview: '待审核',
      returned: '退回',
      transferred: '转单',
      completed: '办结'
    },
  }
}